import React from "react";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MySnackbar = ({ message, open, onClose, severity }) => {
  return (
    <>
      <Snackbar
        open={open}
        onClose={onClose}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          severity={severity}
          sx={{
            position: "absolute",
            top: "128px",
            right: "50%",
            transform: "translate(50%, 0)",
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MySnackbar;
